
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/engage/[client]/minutes-pdf/[agenda]",
      function () {
        return require("private-next-pages/engage/[client]/minutes-pdf/[agenda].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/engage/[client]/minutes-pdf/[agenda]"])
      });
    }
  